import React, { useState } from 'react';

import { AiOutlineCloseCircle } from 'react-icons/ai';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import AddImage from './AddImage';
import { modalNames } from '../../../utils/Objects';
import { closeModal, openModal, setError } from '../../../redux/actions';
import Alerts from '../../common/Alerts';

export default function DiagnosisModal({ newImage, onDiagnosisChange, newDiagnosis, saveDiagnosis, handleImageChange }) {
  const { patient } = useSelector((state) => state.user);
  const { modalName } = useSelector((state) => state.modal);
  // const { message } = useSelector((state) => state.message);
  const distpatch = useDispatch();
  
  const handleDiagnosisChange = ({ name, value }) => {
    onDiagnosisChange(name, value);
    distpatch(setError(''));
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={modalNames.Diagnosis === modalName}
      style={{
        content: { ...styles.centerModal },
      }}
      // onAfterOpen={afterOpenModal}
      onRequestClose={() => distpatch(closeModal())}
      // style={customStyles}
      contentLabel="Diagnosis Modal"
    >
      {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2> */}
      <div style={styles.container}>
        <AiOutlineCloseCircle style={styles.closeButton} onClick={() => distpatch(closeModal())} />

        <div style={styles.title}>Please set new diagnosis:</div>

        <div style={styles.insideContainer}>
          <dl>
            <dt>Apex</dt>
            <dd>
              <input name="apexidentifier" value={newDiagnosis.apexidentifier} onChange={(e) => handleDiagnosisChange(e.target)} />
            </dd>
            <dt>Curve</dt>
            <dd>
              <input name="curveDirection" onChange={(e) => handleDiagnosisChange(e.target)} value={newDiagnosis.curveDirection} />
            </dd>
            <dt>Cobb Angel</dt>
            <dd>
              <input value={newDiagnosis.cobbAngle} name="cobbAngle" onChange={(e) => handleDiagnosisChange(e.target)} />
            </dd>
            <dt>Rotation</dt>
            <dd>
              <input value={newDiagnosis.rotationAngle} name="rotationAngle" onChange={(e) => handleDiagnosisChange(e.target)} />
            </dd>
            <Alerts />
          </dl>
          <AddImage newImage={newImage} onImageChange={handleImageChange} />

          <div
            onClick={() => {
              saveDiagnosis(patient.personalInfo.id, newDiagnosis);
            }}
            style={styles.button}
          >
            Set new Diagnosis
          </div>
        </div>
      </div>
    </Modal>
  );
}

const styles = {
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
  centerModal: {
    width: 600,
    height: 600,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  insideContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // border: '1px solid'
  },
  title: {
    position: 'relative',
    top: -50,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 40,
  },
  button: {
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
};
